export default {
  label: {
    shop: '店铺',
    selectedShop: '已选商城',
    selectedBrand: '已选品牌',
    selectedCategory: '已选分类',
    promoInfo: '活动信息',
    StorePromo: '商店活动',
    OtherPromo: '其他活动',
  },
  button: {
    filter: '筛选',
    searchViaUpload: '上传查询商品',
    submit: '提交',
    favorite: '收藏夹',
    reset: '重置',
  },
  table: {
    image: '图片',
    skuCode: 'SkuCode',
    name: '名字',
    category: '分类',
    brand: '品牌',
    lPrice: '店面价',
    refPrice: '参考价',
    currency: 'USD',
    discount: '最优价',
    grade: '价格评分',
    status: '商品状态',
    maxPriceShop: '最高价商城',
    topLPrice: '店面价',
    maxPrice: '最低价',
    minPriceShop: '最低价商城',
    lowLPrice: '店面价',
    minPrice: '最低价',
    operation: '操作',
    operationButton: '查看详情',
    chDescription: '描述(CH)',
    enDescription: '描述(EN)',
  },
  options: {
    sellingState: {
      all: '状态',
      selling: '在售',
      soldOut: '售罄',
      offShelf: '下架',
    },
    currency: {
      USD: 'USD',
      CNY: 'CNY',
      THB: 'THB',
      EUR: 'EUR',
      HKD: 'HKD',
      SGD: 'SGD',
      AED: 'AED',
    },
    searchType: {
      keyword: '关键字',
      code: 'Code',
      upc: 'UPC',
      search: '查找',
    },
  },
  filterModal: {
    title: '筛选',
    brand: '品牌',
    selected: '已选',
  },
  favoriteModal: {
    tips: {
      noSelect: '请选择一个收藏夹',
    },
    success: {
      noSelect: '添加成功！',
    },
  },
  copyFavoriteSelectModal: {
    title: '复制收藏夹',
  },
  nameShowMsg: {
    text: '点击跳转至网站商品页面',
  },
  refPrice: {
    text: '由商城商品未显示原价，使用其它商城价格参考展示',
  },
};
